import React, {lazy} from 'react'
import { IonButton, IonContent, IonModal, IonIcon, IonAlert, IonProgressBar, IonRow, IonGrid, IonSegment, IonSegmentButton } from "@ionic/react"
import { informationCircle } from 'ionicons/icons';
import WebSocketClient from "../services/WebSocketClient"
import Api from "../services/Api"
import ModalHeader from './ModalHeader'
import "./Login.scss"
import { SafetyPadding } from './SafetyPadding';
import { StoreBadges } from './Badges/StoreBadges';
import './EditWalkInputs.scss'
const UploadPicture = lazy(() => import("./UploadPicture"))

interface ComponentProps {
  // logIn: Function,
  closeModal?: Function,
  page?: string,
  afterLoginPage?: Function
  afterLogin?: string
}

interface ComponentState {
  page: string,
  firstName?: string,
  firstNameError: boolean,
  lastName?: string,
  lastNameError: boolean
  email?: string,
  emailError: boolean
  password?: string,
  passwordError: boolean,
  picture?: string,
  showUploadPicture: boolean,
  submitText: string
  emailPassword: boolean
  resetMailSent: boolean
  errorModal: boolean
  message: string,
  step: Number,
  stepOneError: boolean
  showInfo: boolean
  verified: boolean
}

class Login extends React.Component<ComponentProps, ComponentState> {

  api = Api.getInstance()
  private webSocketClient = WebSocketClient.getInstance()
  state = {
    page: this.props.page ? this.props.page : "start",
    firstName: "",
    firstNameError: false,
    lastName: "",
    lastNameError: false,
    email: this.api.getEmail(),
    emailError: false,
    password: "",
    passwordError: false,
    picture: "assets/images/profile.png",
    showUploadPicture: false,
    emailPassword: false,
    resetMailSent: false,
    submitText: this.api.tr('log_in'),
    message: '',
    errorModal: false,
    step: 0.5,
    stepOneError: false,
    showInfo: false,
    verified: false
  }
  joinTeam = false

  componentDidMount = () => {
    if (window.location.pathname.startsWith('/walk/join/')) {
      this.joinTeam = true
    }
  }


  componentDidUpdate = (prevState: any) => {
    if(prevState.showUploadPicture !== this.state.showUploadPicture) {
      this.scrollToTop()
    }
  }

  scrollToTop = () => {
    window.scrollTo(0, 0);
  }

  closeUploadPicture = () => {
    this.setState({
      showUploadPicture: false
    })
  }

  setPicture(pic: string) {
    this.setState({
      picture: pic
    })
  }

  handleFirstName = (event: any) => {
    this.setState({
      firstName: event.target.value,
      firstNameError: false
    })
  }

  handleLastName = (event: any) => {
    this.setState({
      lastName: event.target.value,
      lastNameError: false
    })
  }

  handleEmail = (event: any) => {
    this.setState({
      email: event.target.value,
      emailError: false
    })
  }

  handlePassword = (event: any) => {
    this.setState({
      password: event.target.value,
      passwordError: false
    })
  }

  pictureOk = () => {
    if (this.state.picture && this.state.picture !== "assets/images/profile.png") {
      return true
    }
    return false
  }

  firstNameOk = () => {
    if (this.state.firstName && this.state.firstName.length > 1) {
      return true
    }
    return false
  }

  lastNameOk = () => {
    if (this.state.lastName && this.state.lastName.length > 1) {
      return true
    }
    return false
  }

  emailOk = () => {
    if (this.state.email && this.state.email.length > 6) {
      if (this.state.email.indexOf('@') > 0) {
        return true
      }
    }
    return false
  }

  passwordOk = () => {
    if (this.state.password && this.state.password.length > 4) {
      return true
    }
    return false
  }

  closeModal = () => {
    if (this.props.closeModal) {
      this.props.closeModal()
      // window.history.pushState({}, '', '/walk/home')
    }
  }

  checkForm = () => {
    let formOk = false

    let message = ''
    if (this.state.page === 'forgot') {
      if (this.emailOk()) {
        formOk = true
      } else {
        message = this.api.tr('login_error_valid_email')
      }
    } else if (this.state.page === 'login') {
      if (this.emailOk() && this.passwordOk()) {
        formOk = true
      } else {
        message = this.api.tr('login_error_correct_email')
      }
    } else if (this.state.page === 'create') {
      if (this.firstNameOk() && this.lastNameOk() && this.emailOk() && this.passwordOk()) {
        formOk = true
      } else {
        message = this.api.tr('needed_to_create')
        message += this.api.tr('needed_fields')
      }
    } else {
      // console.log('Unhandled page: ' + this.state.page)
    }

    this.setState({
      message: message
    })
    return formOk
  }

  changePage = (page: string) => {
    let submitText: string
    if (page === 'create') {
      submitText = this.api.tr('create_account')
    } else if (page === 'login') {
      submitText = this.api.tr('log_in')
    } else if (page === 'forgot') {
      submitText = 'Maila instruktioner'
    } else {
      submitText = 'Okänt fel för ' + page
    }
    this.setState({
      page: page, 
      submitText: submitText,
      firstNameError: false,
      lastNameError: false,
      passwordError: false,
      emailError: false
    })
  }

  logIn = () => {
    if (!this.checkForm()) {
      this.setState({
        errorModal: true
      })
      return
    }

    const data = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      password: this.state.password,
      action: this.state.page,
      picture: this.state.picture
    }

    this.api.post('/login', data).then(response => {
      response.json().then(responseJson => {
        if (responseJson.status === 'ok') {
          this.closeModal()
          if(this.props.afterLogin) {
            this.api.logIn(responseJson.token, this.props.afterLogin)
          } else if (this.joinTeam) {
            // If user is on join team page, stay on that page after login
            this.api.logIn(responseJson.token, window.location.pathname)
          } else {
            this.api.logIn(responseJson.token)
          }
          this.webSocketClient.reOpenSocket()
          this.webSocketClient.sendEvent('session', {type: 'login', status: 'ok'})
          // window.location.href = '/walk/home'
          // goToPage('/walk/home')
        } else {
          this.setState({
            errorModal: true, 
            message: responseJson.message
          })
        }
      })
    })
  }

  sendResetEmail = () => {
    this.setState({
      resetMailSent: true
    })
    this.api.get('password/reset_mail/' + this.state.email).then(response => {
      response.json().then(responseJson => {
        let message: string
        if (responseJson.status === 'ok') {
          message = this.api.tr('new_password_confirmation_part1') + this.state.email + this.api.tr('new_password_confirmation_part2')
        } else {
          message = responseJson.message
        }
        this.setState({
          resetMailSent: true, 
          message: message
        })
      })
    })
  }

  goBack = () => {
    if(this.state.step === 1) {
      this.setState({
        step: 0.5
      })
    } else {
      this.setState({
        page: 'start',
        step: 0.5,
        firstName: '',
        firstNameError: false,
        lastName: '',
        lastNameError: false,
        password: '',
        passwordError: false,
        email: '',
        emailError: false
      })
    }
  }

  errorHandling = () => {
    let formIsValid = true

    if(!this.firstNameOk()) {
      this.setState({
        firstNameError: true
      })
      formIsValid = false
    } else {
      this.setState({
        firstNameError: false
      })
    }

    if(!this.lastNameOk()) {
      this.setState({
        lastNameError: true,
      })
      formIsValid = false
    } else {
      this.setState({
        lastNameError: false,
      })
    } 

    if(!this.emailOk()) {
      this.setState({
        emailError: true,
      })
      formIsValid = false
    } else {
      this.setState({
        emailError: false
      })
    }

    if(!this.passwordOk()) {
      this.setState({
        passwordError: true,
      })
      formIsValid = false
    } else {
      this.setState({
        passwordError: false
      })
    }
    return formIsValid
  }

  nextStep = () => {
    if(this.errorHandling()) {

      if(this.state.step === 0.5) {
        this.setState({
          step: 1
        })
      } else if(this.state.step === 1) {
        this.logIn()
        this.setState({
          step: 2
        })
      }
    } else {
      this.setState({
        stepOneError: true
      })
    }
  }

  changeLanguage = (lang: string) => {
    if (this.api.setLanguage(lang)) {
      document.location.reload();
    } else {
      alert('Could not change to ' + lang)
    }
  }

  render() {
    
    return (
      <>
        { this.state.page === 'start' ? 
          null
          :
          <ModalHeader 
            pageTitle={this.state.submitText} 
            closeModal={this.props.closeModal ? this.closeModal : this.goBack}/>
        }
        <IonContent 
          style={{overflow: "scroll", position: "relative"}}>
          <section 
            className="cheap_desktop safe_margin_footer"
            style={{height: "calc(100% - 70px)", position: "relative"}} 
            >
            <IonAlert
              isOpen={this.state.errorModal}
              onDidDismiss={() => this.setState({ errorModal: false })}
              cssClass='my-custom-class'
              header={this.api.tr('error_message')}
              message={`${this.state.message}`}
              buttons={[`${this.api.tr('close')}`]}
            />
            <IonAlert
              isOpen={this.state.stepOneError}
              onDidDismiss={() => this.setState({ stepOneError: false })}
              cssClass='my-custom-class'
              header={this.api.tr('error_message')}
              message={this.api.tr('create_account_error_all')}
              buttons={[`${this.api.tr('close')}`]}
            />
            {
              this.state.page === 'start' &&
                <IonGrid className="p-4">
                  <IonRow class="mt-2 safe_padding_top">
                    <IonSegment 
                      mode="md"
                      onIonChange={(e) => e.detail.value ? this.changeLanguage(e.detail.value) : null}
                      value={this.api.lang === 'sv' ? 'sv' : 'en'}>
                      <IonSegmentButton value="sv">
                        <img src="assets/icon/se.svg" alt="swedish flag" width="48" height="36"/>
                      </IonSegmentButton>
                      <IonSegmentButton value="en">
                        <img src="assets/icon/gb.svg" alt="british flag" width="48" height="36"/>
                      </IonSegmentButton>
                    </IonSegment>
                  </IonRow>
                  <IonRow className="flex justify-center">
                    <img className="mt-8" width="200px" height="63.77px"  alt="logo" src="assets/images/Blue_Logo_TM.svg" />
                  </IonRow>
                  <section>
                    {/* <h1 className="background_green mt-16 px-2 inline_block color_white">{this.api.tr('welcome_header')}</h1> */}

                    {
                      this.joinTeam ?
                      <h1 className="mt-8 color_blue text_center">
                        {
                          this.api.lang === 'en' ?
                          'You have been invited to a network' : 'Du har blivit inbjuden till ett nätverk'
                        }
                      </h1> :
                      <p className="mt-8">
                        {this.api.tr('welcome_message')}
                      </p>
                    }
                    <IonButton 
                      className="mt-8" 
                      expand="block" 
                      onClick={() => this.changePage('create')}>{this.api.tr('join')}</IonButton>
                    <IonButton
                      className="text_center mt-4"
                      onClick={() => this.changePage('login')}
                      expand="block"
                      fill="outline">
                        {this.api.tr('log_in')}
                    </IonButton>

                    { this.joinTeam ? 
                    <StoreBadges/> : null 
                    }
                  </section>

                </IonGrid>
            }
            {
              this.state.page !== 'start' &&
              <section className="m-4" style={{ position: 'relative', minHeight: "calc(100vh - 140px - 2rem)", paddingTop: "3rem"}}>

                {
                  this.state.page === 'create' ? (
                    <section style={{ position: 'relative' }}>
                      <IonModal 
                        className="uploadImg"
                        isOpen={this.state.showUploadPicture}
                        onDidDismiss={() => this.setState({
                          showUploadPicture: false
                          })}
                         >
                        <UploadPicture 
                          closeModal={this.closeUploadPicture}
                          setPicture={(pic: string) => this.setPicture(pic)}
                          picture="assets/images/profile.png" />
                      </IonModal>
                      { this.state.step === 0.5 ? 
                        <>
                          <h1 className="text_center">{this.api.tr('welcome')}</h1>
                          <p className="mt-4 mb-4 text_center gray_medium">
                            {this.api.tr('create_account_info')}
                          </p>
                        </>
                          :
                        <>
                          <h1 className="text_center">{this.api.tr('upload_profile_picture')}</h1>
                          <p className="mt-4 mb-4 text_center gray_medium">{this.api.tr('almost_ready')}</p>
                        </>
                      }
                      <IonProgressBar value={this.state.step}></IonProgressBar><br />
                      {
                        this.state.step === 0.5 ?
                        <>
                          <article className={`modalInput`}>
                            <input
                              type="text"
                              id="firstName"
                              name="first_name" 
                              value={this.state.firstName}
                              onChange={this.handleFirstName}
                              className={`${this.state.firstNameError ? 'border_error' : `${this.state.firstName !== '' ? 'border_primary' : 'border_gray'}` }`}
                              required/>
                            <label htmlFor="title">{this.api.tr('firstname')}</label>
                          </article>
                          <article className={`modalInput`}>
                            <input
                              type="text"
                              id="lastName"
                              name="last_name" 
                              value={this.state.lastName}
                              onChange={this.handleLastName}
                              className={`${this.state.lastNameError ? 'border_error' : `${this.state.lastName !== '' ? 'border_primary' : 'border_gray'}` }`}
                              required/>
                            <label htmlFor="title">{this.api.tr('lastname')}</label>
                          </article> 
                        </>
                        :
                        <>
             
                        <section  
                          className="mt-8 text_center">
                          <section 
                            className="inline_block"
                            onClick={() => this.setState({
                              showUploadPicture: true
                              })}>
                            <img 
                              alt="profile" 
                              className="circle_large box_shadow" 
                              style={{ width: "58px", height: "58px" }}
                              src={this.state.picture}/>
                          </section>
                          <p 
                            className="mt-4 text_link"
                            onClick={() => this.setState({
                              showUploadPicture: true
                              })}>{this.api.tr('upload_profile_picture')}
                          </p>
                          <IonIcon 
                            icon={informationCircle} 
                            size="large"
                            onClick={() => this.setState({ showInfo: true })}/>   
                        </section>
                        </>
                      }

                    </section>
                    ) : (
                      <>
                        <h1 className="text_center">{this.api.tr('welcome')}</h1>

                        <p className="mt-4 mb-4 text_center gray_medium">
                          {this.api.tr('log_in_info')}
                        </p>
                      </>
                    )

                }
                { this.state.step === 0.5 ? 
                <>
                  <article className={`modalInput`}>
                    <input
                      type="text"
                      id="email"
                      name="email" 
                      value={this.state.email} 
                      onChange={this.handleEmail}
                      className={`${this.state.emailError ? 'border_error' : `${this.state.email !== '' ? 'border_primary' : 'border_gray'}` }`}
                      required/>
                  <label htmlFor="title">{this.api.tr('email')}</label>
                </article>
                <article className={`modalInput`}>
                  <input
                    type="password"
                    id="firstName"
                    name="walkpwd"
                    value={this.state.password} 
                    onChange={this.handlePassword}
                    className={`${this.state.passwordError ? 'border_error' : `${this.state.password !== '' ? 'border_primary' : 'border_gray'}` }`}
                    required/>
                  <label htmlFor="title">{this.api.tr('password')}</label>
                </article>
                </>
                : null }
                

                { this.state.page === 'login' ? 
                  <IonButton 
                    className="mt-8" 
                    expand="block" 
                    onClick={() => this.logIn()}>
                    {this.state.submitText}
                  </IonButton>
                  : null
                }

                { (this.state.page === 'create' && this.state.step === 0.5) || this.state.step === 1 ?
                    <IonButton 
                      className="mt-8" 
                      expand="block" 
                      onClick={() => this.nextStep()}>
                      {this.api.tr('next_step')}
                    </IonButton>
                : null }


                {
                  this.state.page === 'create' ? (
                    <section className="my-4 gray_medium">
                      {this.api.tr('create_account_GDPR')}
                      <a href="https://www.walkingtalking.se/anvandarvillkor/" className="text_link">{this.api.tr('user_agreement')}</a>.
                    </section>
                    ) : (
                  <div className="mt-8">
                    {
                      this.state.resetMailSent ? (
                        <p className="mt-4">
                          {this.api.tr('new_password_confirmation_part1')} {this.state.email}.<br/>
                          {this.api.tr('new_password_confirmation_part2')}
                        </p>
                      ) : (
                        <>
                          <p 
                          className="text_center text_link" 
                          onClick={() => this.setState({ emailPassword: true })}>
                            {this.api.tr('forgotten_password')}
                          </p>
                          {
                            this.state.emailPassword &&
                            <>
                            {
                              this.emailOk() === false ? (
                                <p className="mt-4">{this.api.tr('need_email_reset')}</p>
                              ) : (
                                <IonButton 
                                  className="mt-4" 
                                  expand="block" 
                                  onClick={() => this.sendResetEmail()}>
                                  {this.api.tr('send_new_password')}
                                </IonButton>
                              )
                            }
                            </>
                          }
                        </>
                      )
                    }
                  </div>
                  )
                }
                { this.state.page !== 'start' && !this.state.showUploadPicture ?
                <>
                  { this.state.page === 'create' ? 
                    <p className="color_green text_center mt-8">{this.api.tr('have_account')}
                      <b className="text_link" onClick={() => {
                        this.setState({
                          page: 'login',
                          submitText: `${this.api.tr('log_in')}`,
                          firstName: '',
                          firstNameError: false,
                          lastName: '',
                          lastNameError: false,
                          password: '',
                          passwordError: false,
                          email: '',
                          emailError: false,
                          step: 0.5,
                        })
                        }}> {this.api.tr('log_in')}
                      </b>
                    </p>
                    : 
                    <p className="color_green text_center mt-8">{this.api.tr('have_no_account')}
                      <b className="text_link" onClick={() => {
                        this.setState({
                          page: 'create',
                          submitText: 'Skapa konto',
                          firstNameError: false,
                          lastNameError: false,
                          passwordError: false,
                          emailError: false
                        })
                        }}> {this.api.tr('register_account')}
                      </b>
                    </p>
                  }
                </>
                : null
                }

              </section>
            }
          </section>
          <SafetyPadding/>
          </IonContent>

          <IonAlert
            isOpen={this.state.showInfo}
            onDidDismiss={() => this.setState({ showInfo: false })}
            cssClass='my-custom-class'
            header={this.api.tr('image_info_header')}
            message={`${this.api.tr('image_info_message')} </br></br> <b>${this.api.tr('tip')}</b> ${this.api.tr('image_info_tips')}`}
            buttons={[`${this.api.tr('close')}`]}
          />
        </>
    )
  }
}

export default Login
